const maxMessageLength = 200
const stackFrameSeparator = "   at "

/**
 * Pulls the readable part out of a failed XHR body, dropping the exception type and stack
 * trace. Returns null if there is nothing usable, such as a proxy's HTML error page.
 */
const getXhrErrorMessage = (responseText: string | null): string | null => {
	if (!responseText) {
		return null
	}

	const firstLine = responseText.split("\n")[0].trim()
	if (!firstLine || firstLine.startsWith("<")) {
		return null
	}

	const withoutExceptionType = firstLine.replace(/^[\w.]+(Exception|Error): /, "")
	const message = withoutExceptionType.split(stackFrameSeparator)[0].trim()
	if (!message) {
		return null
	}

	return message.length > maxMessageLength ? `${message.substring(0, maxMessageLength)}…` : message
}

export { getXhrErrorMessage }
